import mediaPreview1 from './template/MediaPreview1.webp';
import mediaPreview2 from './template/MediaPreview2.webp';
import placeholderSlot from './template/PlaceholderSlot.webp';

/**
 * Placeholder image displayed when no foreground or background images are available
 * or when all images fail to load.
 */
export const MEDIA_PREVIEW_PLACEHOLDER = placeholderSlot;
export const MEDIA_PREVIEW_BANNER = 1;
export const MEDIA_PREVIEW_CARD = 2;

/**
 * Configuration object for different media preview types.
 * Each type defines the template image, dimensions, border radius, and overlay positioning.
 *
 * Structure:
 * - template: The base template image URL
 * - width: Template width in pixels
 * - height: Template height in pixels
 * - templateBorderRadius: Border radius for the template image
 * - overlay: Object defining the overlay area where media is displayed
 *   - x: Horizontal offset from left edge
 *   - y: Vertical offset from top edge
 *   - width: Overlay width
 *   - height: Overlay height
 *   - borderRadius: Border radius for the overlay area
 */
export const MEDIA_PREVIEW_CONFIG = {
  // Type 1: Full-width portrait preview with top overlay
  [MEDIA_PREVIEW_BANNER]: {
    label: 'Banner',
    template: mediaPreview1,
    width: 750,
    height: 1040,
    templateBorderRadius: '10px 10px 10px 10px',
    overlay: {
      x: 0,
      y: 0,
      width: 750,
      height: 492,
      borderRadius: '10px 10px 0 0'
    }
  },
  // Type 2: Horizontal banner preview with left-side overlay
  [MEDIA_PREVIEW_CARD]: {
    label: 'Card',
    template: mediaPreview2,
    width: 686,
    height: 212,
    templateBorderRadius: '22px 0 0 22px',
    overlay: {
      x: 2,
      y: 2,
      width: 142,
      height: 208,
      borderRadius: '22px 0 0 22px'
    }
  }
};

/**
 * Default preview type to use when an unsupported type is provided.
 */
export const DEFAULT_MEDIA_PREVIEW_TYPE = MEDIA_PREVIEW_BANNER;
